<script setup lang="ts">
import createOrUpdateSubManagementOffice from "@/types/requests/createOrUpdateSubManagementOffice"
import { computed, defineProps, defineEmits } from 'vue';
import i18n from '@/lang/i18n'

const props = defineProps<{
  modelValue: createOrUpdateSubManagementOffice
  errors: any
  windowInnerWidth: number
}>()

const emits = defineEmits(['update:modelValue'])

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emits("update:modelValue", value);
  },
})
</script>
<template>
  <v-row class="text-form pl-4 pr-3 mb-3">
    <v-col cols="2">
      <h6 class="pl-4 align-center">
        {{ i18n.global.t('pages.subManagementOffice.telephoneNumber') }}
      </h6>
    </v-col>
    <v-col cols="4">
      <v-text-field
        v-model="modelValue.telephone_number"
        maxlength="11"
        :error-messages="errors.telephone_number"
      />
    </v-col>
    <v-col cols="2">
      <h6 class="pl-4 align-center">
        {{ i18n.global.t('pages.subManagementOffice.form.faxNumber') }}
      </h6>
    </v-col>
    <v-col cols="4">
      <v-text-field
        v-model="modelValue.fax_number"
        maxlength="11"
        :error-messages="errors.fax_number"
      />
    </v-col>
  </v-row>
</template>